<template>
  <div>
    <van-form ref="paymentForm" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;background-color: #fff;padding: 5px;">
      <van-tag type="warning">短信信息</van-tag>
      <van-cell title="短信内容" required :border="false"></van-cell>
      <van-field v-model="paymentForm.msgContent" rows="5" @input="smsTell" clearable autosize type="textarea" placeholder="请粘贴短信内容" style="border: 1px solid #d4d4d4; border-radius: 5px" />
      <van-tag type="success" style="margin-top: 12px;">识别信息</van-tag>
      <van-field v-model="paymentForm.custName" label="付款单位" placeholder="请输入付款单位" :rules="[{ required: true }]" required />
      <van-field v-model="paymentForm.companyName" readonly @click="showPicker('company')" label="收款主体" placeholder="请选择收款主体" :rules="[{ required: true }]" required />
      <van-field v-model="paymentForm.incomeBankName" readonly @click="paymentForm.companyId?showPicker('incomeBank'):''" label="收款银行账号" placeholder="请选择收款银行账号" :disabled="!paymentForm.companyId" :rules="[{ required: true }]" required />
      <van-field v-model="paymentForm.payMoney" label="收款金额(元)" placeholder="请输入金额" :rules="[{ required: true }]" type="number" maxlength="11" required />
      <van-field v-model="paymentForm.payDate" readonly clickable name="calendar" label="收款时间" placeholder="点击选择收款时间" @click="showDatePicker" :rules="[{ required: true }]" required />
      <div style="text-align: center;margin-top: 10px;">
        <van-button size="small" type="info" @click="savePayment" style="padding: 0 20px; border-radius: 5px;">保存</van-button>
        <van-button size="small" type="warning" native-type="button" @click="paymentForm = {}" style="padding: 0 20px; border-radius: 5px;margin-left: 10px">清空</van-button>
        <!-- <van-button size="small" type="default" @click="paymentVisible = false" style="padding: 0 20px; border-radius: 5px;margin-left: 10px">取消</van-button> -->
      </div>
    </van-form>
    <van-popup v-model="picker.visible" position="bottom">
      <van-picker :loading="picker.loading" :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" />
    </van-popup>
    <van-popup v-model="datePicker.visible" position="bottom">
      <van-datetime-picker v-model="datePicker.date" type="datetime" title="选择收款时间" :min-date="datePicker.minDate" @confirm="datePickerConfirm" @cancel="datePicker.visible = false" />
    </van-popup>
  </div>
</template>

<script>
import payment from '@/api/cont/payment'
import { Toast, Tab, Tabs, DatetimePicker } from 'vant'
import { companyList } from '@/api/admi/dept'

export default {
  name: 'approve',
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [DatetimePicker.name]: DatetimePicker,
    [Toast.name]: Toast
  },
  data() {
    return {
      add_show: false,
      isEmpty: false,
      active: 0,
      loading: false,
      finished: false,
      list: [],
      total: 0,
      countItem: {},
      showFilterPop: false,
      custList: [],
      paymentFormShow: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        checkStatus: null,
        companyId: null,
        orderByColumn: 'createTime',
        isAsc: 'desc'
      },
      statusArr: ['', '未认领公海', '未认领', '部分认领', '已认领', '异常'],
      typeArr: ['', 'danger', 'danger', 'warning', 'success', 'primary'],
      paymentVisible: false,
      paymentForm: {},
      picker: {
        visible: false,
        title: '',
        columns: [],
        formKey: '',
        loading: false
      },
      deptList: [],
      payBankList: [],
      datePicker: {
        visible: false,
        date: new Date(),
        minDate: new Date(2020, 0, 1)
        // maxDate: new Date(2042, 11, 31)
      }
    }
  },
  created() {
    // if (this.$route.query.active) {
    //   this.active = this.$route.query.active
    //   this.queryParams.checkStatus = this.$route.query.active
    // }
    // this.handleList()
    // this.getCountItem()
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      document.title = '新增收款'
    },
    handleAddPayment() {
      this.paymentVisible = true
    },
    getPayBankList(id) {
      this.payBankList = []
      payment.listPayBank({ companyId: id }).then((response) => {
        if (response.code === 200) {
          response.rows.forEach(item => {
            const obj = {
              incomeBankId: item.bankAccountId,
              incomeBankName: `${item.bankName}(${item.accountNum})`,
              incomeBankNo: item.accountNum
            }
            this.payBankList.push(obj)
          })
        }
      })
    },
    smsTell(val) {
      payment.smsTell({ msgContent: val }).then(res => {
        if (res.code == 200) {
          this.getPayBankList(res.data.companyId)
          this.paymentForm = res.data
          this.paymentForm.incomeBankName = `${this.paymentForm.payBank}(${this.paymentForm.payBankAccountNo})`
          this.datePicker.date = new Date(this.paymentForm.payDate)
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    async showPicker(type) {
      this.picker.loading = true
      this.picker.columns = []
      this.picker.formKey = type
      const optionItem = type + 'Options'
      if (type == 'company') {
        // 获取公司信息
        if (this.deptList.length == 0) {
          await companyList({ isAll: 1 }).then((response) => {
            this.deptList = response.rows
          })
        }
        this.picker.columns = this.deptList.map((ele) => ele.companyName)
        this.picker.loading = false
      } else if (type == 'incomeBank') {
        // await this.getPayBankList(this.paymentForm.companyId)
        this.picker.columns = this.payBankList.map((ele) => ele.incomeBankName)
        this.picker.loading = false
      } else {
        this.picker.columns = this.options[optionItem].map((ele) => ele.dictLabel)
        this.picker.loading = false
      }
      this.picker.visible = true
    },
    async pickerConfirm(value, key) {
      const optionItem = this.picker.formKey + 'Options'
      const name = this.picker.formKey + 'Name'
      if (this.picker.formKey === 'company') {
        this.paymentForm.companyName = this.deptList[key].companyName
        this.paymentForm.companyId = this.deptList[key].companyId
        await this.getPayBankList(this.paymentForm.companyId)
        this.paymentForm.incomeBankId = ''
        this.paymentForm.incomeBankName = ''
      } else if (this.picker.formKey === 'incomeBank') {
        this.paymentForm.incomeBankId = this.payBankList[key].incomeBankId
        this.paymentForm.incomeBankName = this.payBankList[key].incomeBankName
      } else {
        this.paymentForm[this.picker.formKey] = this.options[optionItem][key].dictValue
        this.paymentForm[name] = this.options[optionItem][key].dictLabel
      }
      this.picker.visible = false
    },
    pickerCancel() {
      this.picker.visible = false
    },
    showDatePicker() {
      this.datePicker.visible = true
    },
    datePickerConfirm(val) {
      this.paymentForm.payDate = this.formatDateTime(val)
      this.datePicker.visible = false
    },
    formatDateTime(date) {
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? ('0' + m) : m
      var d = date.getDate()
      d = d < 10 ? ('0' + d) : d
      var h = date.getHours()
      h = h < 10 ? ('0' + h) : h
      var minute = date.getMinutes()
      minute = minute < 10 ? ('0' + minute) : minute
      var second = date.getSeconds()
      second = second < 10 ? ('0' + second) : second
      return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second
    },
    async savePayment() {
      await this.$refs.paymentForm.validate
      payment.addNewIncome(this.paymentForm).then(res => {
        if (res.code == 200) {
          Toast.success('新增收款成功')
          this.paymentVisible = false
          this.paymentForm = {}
          this.queryCustList()
        } else {
          Toast.fail(res.msg)
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import url("@/style/index.less");

</style>
